<template>
  <Modal
    v-if="showModal"
    id="popup-system-notice"
    :title="systemNotice.title"
    :active.sync="isOpen"
    @close="dontShowAgain"
  >
    <div v-html="systemNotice.html"></div>
  </Modal>
</template>
<script>
import Modal from '../../components/Modal.vue';
import { getDataLoginDefault } from '../../services/multiple-empresa';
import functions from '../../utils/functions';

export default {
  name: 'modal-news',
  components: {
    Modal,
  },
  data() {
    return {
      isOpen: false,
      systemNotice: JSON.parse(getDataLoginDefault().systemNotice || {}),
    };
  },
  computed: {
    showModal() {
      const showNewsModal =
        functions.getFromLocalStorageByKey('show-news-modal');

      const modalNewsActive = this.systemNotice.active;
      return modalNewsActive === true && showNewsModal === 'true';
    },
  },
  mounted() {
    this.openModal();
  },
  methods: {
    openModal() {
      if (this.showModal) {
        this.isOpen = true;
      }
    },
    dontShowAgain() {
      functions.setInLocalStorageByKey('show-news-modal', 'false');
    },
  },
};
</script>
<style>
#popup-system-notice.con-vs-popup .vs-popup {
  width: fit-content !important;
  height: fit-content !important;
}

.ql-align-center {
  text-align: center;
}

.ql-align-right {
  text-align: right;
}

.ql-align-center img {
  display: block;
  margin: 0 auto;
}

.ql-align-right img {
  display: block;
  margin-left: auto;
}

.ql-align-center iframe {
  display: block;
  margin: 0 auto;
}

.ql-align-right iframe {
  display: block;
  margin-left: auto;
}
</style>
